module.exports = __webpack_public_path__ + "img/banner.39f3d2d1.png";